import type { ServiceWorkerSmsListApiData, ServiceWorkerSmsListApiResponses } from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const serviceWorkerSmsUrls = {
  getPaginatedServiceWorkerSMS: dataEndpoint<ServiceWorkerSmsListApiData, ServiceWorkerSmsListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-worker-sms/', queryParams)
  })
};
